import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { useHistory } from "react-router";

import { Row, Col, Button, Select, PageHeader, Switch , Grid} from "antd";

import SectionList from "./SectionList";
import AssignEmployeeModal from "./AssignEmployee"
import DraggableTable from "./DraggableTable";

const { useBreakpoint } = Grid;

const TableConfiguration = ({
  tableData,waitlist,servers,isFromAddPopup,addedTables,selectedTable,selectAllTables
}) => {
  const history = useHistory();
  const screens = useBreakpoint();

  const draggedType = useRef(null);
  const sectionZone = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [showExpanded, setShowExpanded] = useState(false);
  const [showCapacity, setShowCapacity] = useState(false);
  const [modalData, setModalData] = useState();
  const [floor, setFloor] = useState(0);
  const [sectionData, setSectionData] = useState([]);
  const [sectionDataDefault, setSectionDataDefault] = useState([]);
  const [freeTables, setFreeTables] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState();

  useEffect(() => {
    setFreeTables(tableData?.sectionData?tableData?.sectionData:[])
    setSelectedSectionId(tableData?.sectionData?.length>0?tableData?.sectionData[0].id:0)
    setFloor(tableData?.sectionData?.length>0?tableData?.sectionData[0].floor:0)
    setSectionData(tableData?.sectionData?.length>0?tableData?.sectionData[0].sectionsMap:[])
    setSectionDataDefault(tableData?.sectionData?.length>0?tableData?.sectionData[0].sectionsMap:[])

    
  }, [tableData]);

  const selectAllTableFromFloor = ()=>{

    const allSections = tableData?.sectionData
  .map(item => item.sectionsMap.map(section => section.sections))
  .flat(2) // Flatten the nested arrays two levels deep
  .filter(section => section !== null); // Remove null values

    selectAllTables(allSections.filter(item => item != undefined))
  }

  const saveMapping = async () => {
    const saveMap = freeTables.map(item=>{
       
        
      const sectionsMap =item.sectionsMap.filter(itemundefined=> itemundefined != undefined).map((itemMap)=>{
          
            const obj={
              sections : itemMap.sections.filter(itemundefinedSec=> itemundefinedSec != undefined).map(itemSection=>{
                const newObj={
                  table_number:itemSection.table_number,
                  table_type_id: itemSection.id,
                  "employee_id": 3,
                  section_id: item.id,
                  is_occupied: false,
                }
                return newObj
                
              })
            }
            

            return obj;
          
        })

        return sectionsMap;

      
    })
    
    const newmap = [].concat(...saveMap);
    const updated = [].concat(...newmap);
    const savedMapArray =[].concat(...updated.map(item=>item.sections));
    // saveTableConfig(savedMapArray)
    
  };

  const updateSection=(item,section,selectedItem)=>{
      setModalData({data:item,section:section?.filter(item=> item != undefined),selectedSection:selectedItem})
      setShowModal(true)
  }

  const onChange = (checked) => {
    setShowCapacity(checked)
  };

  const setExpanded =(value,item,bg,color,number)=>{
    if(value)
    {
      setSectionData([{sections:item,bg:bg,color:color,number:number}])
      setShowExpanded(value)
    }
    else{
      setSectionData(sectionDataDefault)
      setShowExpanded(value)

    }
    
  }

  return (
    <div
      className={"table-management-card table-configure " + (!screens.md && "mobile-table-management-card")}
      onDragOver={(e) => e.preventDefault()}
      // onDrop={outsideDrop}
    >
      <div className="drag-div" style={{flexWrap:"wrap"}}>
        {!isFromAddPopup &&
      <PageHeader
          title={`Seating Arrangement`}
          onBack={() => history.goBack()}
          className="page-header-business"
        />
}
{!isFromAddPopup &&
        <div>Show capacity:  <Switch  onChange={onChange} /></div>
}
    {isFromAddPopup && <Button type="primary" onClick={()=>selectAllTableFromFloor()}>Select All</Button>}
      <Select
        value={floor}
        style={{
          width: 120,
          float: "right",
        }}
        onChange={(e) => {
          let dataSec =[];
          console.log(e)
    const floornum = tableData?.sectionData.find(item=>parseInt(item.floor) == parseInt(e))
     
    setSelectedSectionId(floornum?.id)
    setSectionData(floornum?.sectionsMap)
    setSectionDataDefault(floornum?.sectionsMap)
          setFloor(e);
          
        }}
        options={freeTables.map((val, index) => {
          return {key:val.id, value: val.floor, label: `Floor ${val.floor}` };
        })}
      />
</div>
    

    

      <Row
        style={{
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
          marginTop: "2rem",
          marginBottom: "2rem",
        }}
       
      >
        {sectionData && sectionData?.map((item, i) => (
         
           <SectionList sectionItems={item.sections} i={i} sectionDataItem={sectionData}
           dataItem={item}
            key={item.id}
           showExpanded={showExpanded}
           setShowExpanded={setExpanded}
           isFromAddPopup = {isFromAddPopup}
           addedTables = {addedTables}
           selectedTable= {selectedTable}
           updateSection={updateSection}/>
          
        ))}
      </Row>
      {showCapacity &&
      <div className="draggable-floor">
      {tableData?.tableData?.map((item, i) => (
<DraggableTable text ={item}/> 
   ))}
</div>
}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          margin: "1rem",
        }}
      >
        <Button
          type="primary"
          style={{ paddingRight: "3rem", paddingLeft: "3rem" }}
          onClick={saveMapping}
        >
          Save
        </Button>
      </div> */}

{showModal &&
 <AssignEmployeeModal 
        data={modalData}
        modalOpen={showModal}
        waitlist={waitlist}
         closeModal={setShowModal}
         servers={servers}
      />
}
    </div>
  );
};

export default TableConfiguration;
